import { Form, FormList, FormSubtypeEnum, FormTypeEnum, TemplateOrder } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';
import {
    LoadingFormsStartAction,
    LoadingFormsSuccessAction,
    LoadingFormsErrorAction,
    FormDeleteStartAction,
    FormDeleteSuccessAction,
    FormDeleteErrorAction,
    ArrayOfFormsDeleteSuccessAction,
    ArrayOfFormsDeleteErrorAction,
    ArrayOfFormsDeleteStartAction,
    FormActionTypes,
    CopyFormStartAction,
    CheckIfHaveClassicFormsStartAction,
    CheckIfHaveClassicFormsSuccessAction,
    CheckIfHaveClassicFormsErrorAction,
} from './types';

export interface StartLoadingFormsParams {
    page?: number;
    limit?: number;
    formsOrder?: TemplateOrder;
    search?: string;
    formTypes?: FormTypeEnum[] | null;
    formSubtypes?: FormSubtypeEnum[] | null;
    offset?: number;
    formList?: Form[];
}

export const LoadingFormsStart: ActionCreator<LoadingFormsStartAction> = (
    params: StartLoadingFormsParams
): LoadingFormsStartAction => ({
    type: FormActionTypes.LOADING_START,
    payload: {
        page: params.page,
        limit: params.limit,
        loadingForms: true,
        formTypes: params.formTypes,
        formSubtypes: params.formSubtypes,
        search: params.search,
        formsOrder: params.formsOrder,
    },
});

export const LoadingFormsSuccess: ActionCreator<LoadingFormsSuccessAction> = (
    formList: FormList,
    formsCount: number,
    globalFormsCount: number
): LoadingFormsSuccessAction => ({
    type: FormActionTypes.LOADING_SUCCESS,
    payload: {
        formList,
        formsCount,
        globalFormsCount,
        loadingForms: false,
    },
});

export const LoadingFormsError: ActionCreator<LoadingFormsErrorAction> = (): LoadingFormsErrorAction => ({
    type: FormActionTypes.LOADING_ERROR,
    payload: {
        loadingForms: false,
    },
});

export const CheckIfHaveClassicFormsStart = (): CheckIfHaveClassicFormsStartAction => ({
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_START,
});

export const CheckIfHaveClassicFormsSuccess = (haveClassicForms: boolean): CheckIfHaveClassicFormsSuccessAction => ({
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_SUCCESS,
    payload: {
        haveClassicForms,
    },
});

export const CheckIfHaveClassicFormsError = (): CheckIfHaveClassicFormsErrorAction => ({
    type: FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_ERROR,
});

export const FormDeleteStart: ActionCreator<FormDeleteStartAction> = (formName: string): FormDeleteStartAction => ({
    type: FormActionTypes.DELETE_START,
    payload: {
        formName,
        loadingForms: true,
    },
});

export const FormDeleteSuccess: ActionCreator<FormDeleteSuccessAction> = (
    formName: string
): FormDeleteSuccessAction => ({
    type: FormActionTypes.DELETE_SUCCESS,
    payload: {
        formName,
        loadingForms: false,
    },
});

export const FormDeleteError: ActionCreator<FormDeleteErrorAction> = (formName: string): FormDeleteErrorAction => ({
    type: FormActionTypes.DELETE_ERROR,
    payload: {
        formName,
        loadingForms: false,
    },
});

export const ArrayOfFormsDeleteStart: ActionCreator<ArrayOfFormsDeleteStartAction> = (
    formNames: Array<string>
): ArrayOfFormsDeleteStartAction => ({
    type: FormActionTypes.DELETE_ARRAY_START,
    payload: {
        formNames,
        loadingForms: true,
    },
});

export const ArrayOfFormsDeleteSuccess: ActionCreator<ArrayOfFormsDeleteSuccessAction> = (
    formNames: Array<string>
): ArrayOfFormsDeleteSuccessAction => ({
    type: FormActionTypes.DELETE_ARRAY_SUCCESS,
    payload: {
        formNames,
        loadingForms: false,
    },
});

export const ArrayOfFormsDeleteError: ActionCreator<ArrayOfFormsDeleteErrorAction> = (
    formNames: Array<string>
): ArrayOfFormsDeleteErrorAction => ({
    type: FormActionTypes.DELETE_ARRAY_ERROR,
    payload: {
        formNames,
        loadingForms: false,
    },
});

export const CopyFormStart = (formName: string): CopyFormStartAction => ({
    type: FormActionTypes.COPY_START,
    payload: { formName },
});
